module.exports = __webpack_public_path__ + "img/nav-right-with-contact-mitsu.12e826db.png";